module.exports = __webpack_public_path__ + "static/media/star-sturgeon.348d5af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/star-sturgeon.png
// module id = 336
// module chunks = 0